import * as R from "ramda"
import * as R_ from "ramda-extension"

import FluxStore from "flux/lib/FluxStore"
import { AppDispatcher } from "@cirrus/legacy/app-common/dispatcher"

export default function (name, options, dispatcher) {
  var _handlers = {}

  if (!dispatcher) {
    dispatcher = AppDispatcher
  }
  var store = new FluxStore(dispatcher)
  store = Object.assign(store, options)
  store = Object.assign(store, {
    __onDispatch: (action) => {
      var handler = _handlers[action.type]
      if (!handler) return
      handler.call(this, action)
    },
  })

  R.keys(R.filter(R_.isFunction, options)).forEach((name) => {
    let func = options[name]
    store[name] = func.bind(store)
  })

  if (store.handlers) {
    Object.keys(store.handlers).forEach((actionType) => {
      //handler can be either anonymous function or instance-method
      var handler = store.handlers[actionType]
      if (R_.isString(handler)) {
        //it is a simply action name
        var func = store[handler]
        if (R_.isFunction(func)) {
          _handlers[actionType] = func
        }
      } else if (R_.isFunction(handler)) {
        // it is a function
        _handlers[actionType] = handler
      }
    }, this)
  }
  return store
}
